export default __webpack_public_path__ + "static/media/date.281d1656.svg";